import { getCookie } from "./get-cookie";
import { parseJwt } from "./parse-jwt";

export const getEmailFromToken = (): string => {
  const token = getCookie("id_token");
  if (token) {
    return parseJwt(token).email;
  } else {
    return "";
  }
};
